import React from "react";

export const CoupenList = React.lazy(() => import("./CoupenList"));
export const CreateEditCoupen = React.lazy(() => import("./CreateEditCoupen"));
export { default as UsedCoupon } from "./UsedCoupon";
